<ng-container *ngIf="activeNotifications.length > 0">
    <ng-container *ngFor="let notification of activeNotifications">
        <ridango-basic-error-notification
            *ngIf="notification.type === notifications.notificationTypes.ERROR"
            [notification]="notification">
        </ridango-basic-error-notification>
        <ridango-basic-information-notification
            *ngIf="notification.type === notifications.notificationTypes.INFORMATION"
            [notification]="notification">
        </ridango-basic-information-notification>
        <ridango-basic-success-notification
            *ngIf="notification.type === notifications.notificationTypes.SUCCESS"
            [notification]="notification">
        </ridango-basic-success-notification>
        <ridango-basic-information-notification-v2
            *ngIf="notification.type === notifications.notificationTypes.INFORMATION_V2"
            [notification]="notification">
        </ridango-basic-information-notification-v2>
    </ng-container>
</ng-container>
